class CheckoutCoupons {
  constructor() {
    jQuery('.mad-remove-coupon').click(this.removeCoupon.bind(this))
    jQuery(document.body).on('updated_checkout', () => {
      jQuery('.mad-remove-coupon').click(this.removeCoupon.bind(this))
      if (ScrollTrigger) ScrollTrigger.refresh();
    })

    jQuery('form.mad-coupon-form').on('submit', this.submit.bind(this));
  }

  removeCoupon(e) {
    e.preventDefault();

    // console.log('js remove coupon')

    var orderReviewContainer = jQuery('.mad-checkout-order-review');
    var couponElement = jQuery(e.target).closest('.mad-remove-coupon');
    var coupon = couponElement.data('coupon');

    if (!coupon) {
      console.error('Coupon code not found');
      return;
    }

    // TODO: Add processing indicator e.g. loading animation

    var data = {
      security: wc_checkout_params.remove_coupon_nonce,
      coupon: coupon
    };

    jQuery.ajax({
      type: 'POST',
      url: wc_checkout_params.wc_ajax_url.toString().replace('%%endpoint%%', 'remove_coupon'),
      data: data,
      success: function (code) {
        jQuery('.woocommerce-error, .woocommerce-message, .is-error, .is-success').remove();
        // TODO: Remove processing indicator

        if (code) {
          
          jQuery('form.mad-coupon-form').before(code);
          jQuery('.mad-checkout-order-review__discount.coupon-' + data.coupon).remove();
          // Remove coupon code from coupon field
          jQuery('form.mad-coupon-form').find('input[name="coupon_code"]').val('');

          jQuery(document.body).trigger('removed_coupon_in_checkout', [data.coupon]);
          jQuery(document.body).trigger('update_checkout', {
            update_shipping_method: false
          });
          
        }
      }.bind(this),
      error: function (jqXHR) {
        if (wc_checkout_params.debug_mode) {
          /* jshint devel: true */
          console.log(jqXHR.responseText);
        }
      },
      dataType: 'html'
    });
  }

  submit(e) {
    e.preventDefault();
    // console.log('Submit coupon!');
    // TODO: Check if processing

    var data = {
      security:		wc_checkout_params.apply_coupon_nonce,
      coupon_code:	jQuery('form.mad-coupon-form').find('input[name="coupon_code"]').val()
    };

    // console.log('data', data)

    jQuery.ajax({
      type:		'POST',
      url:		wc_checkout_params.wc_ajax_url.toString().replace('%%endpoint%%', 'apply_coupon'),
      data:		data,
      success:	function(code) {
        // jQuery('.woocommerce-error, .woocommerce-message, .is-error, .is-success').remove();
        
        // Remove processing

        if (code) {
          jQuery('form.mad-coupon-form').before(code);

          jQuery(document.body).trigger('applied_coupon_in_checkout', [ data.coupon_code ]);
          jQuery(document.body).trigger('update_checkout', { update_shipping_method: false });
        }
      }.bind(this),
      dataType: 'html'
    });
  }
}

module.exports = CheckoutCoupons